export class DataFactorySubscription {
  public id: string;
  public subscriptionId: string;
  public resourceGroupId: string;
  public dataFactoryId: string;
}

export class DataFactoryPipeline {
  public id: string;
  public subscriptionId: string;
  public name: string;
  public templateId: string;
  public isActive: boolean;
  public displayName: string;
}
